import React, { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { CommunityFeedType, FeedLikeType } from "../../types";
import {
  Activity,
  CommentList,
  ModalContent,
  DiscussMenu,
  ModalActivityReader,
  DiscussImage,
  CommunityFooter,
  DiscussCommentModal,
  DiscussVideoImage,
  DiscussVideo,
  CommentsPost,
} from "..";
import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from "@apollo/client";
import { CREATE_FEED_COMMENT } from "../../apollo/operations";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { showToast } from "../../utils/showToast";

type DiscussModalProps = {
  openModal: boolean;
  onClose: () => void;
  communityFeed: CommunityFeedType | undefined;
  textArea: React.RefObject<HTMLTextAreaElement | null>;
  refetch?: () => void;
  inputArea: React.RefObject<HTMLInputElement | null>;
  feedImages: string[] | undefined;
  isRefetching?: () => void;
  feedVideo: string[];
  loadData?: boolean;
  isLocked?: boolean | (() => void);
  refetchLikes: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<any>>;
  feedLikes: FeedLikeType | undefined;
  loading: boolean;
  loadings: boolean;
  setLoadings: React.Dispatch<React.SetStateAction<boolean>>;
  setModalRemove: React.Dispatch<React.SetStateAction<boolean>>;
  modalRemove: boolean;
};
const DiscussModal: React.FC<DiscussModalProps> = ({
  openModal,
  onClose,
  communityFeed,
  textArea,
  refetch,
  inputArea,
  feedImages,
  isRefetching,
  feedVideo,
  loadData,
  isLocked,
  feedLikes,
  loading,
  refetchLikes,
  loadings,
  setLoadings,
  setModalRemove,
  modalRemove,
}) => {
  // const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);
  const [communityComment, setCommunityComment] = React.useState("");
  const [showAllImages, setShowAllImages] = React.useState<number | null>(null);
  const [onChange, setOnChange] = React.useState(false);
  // const dispatch = useDispatch();
  // const communityFeeds: CommunityFeedType[] = useSelector(
  //   (state: any) => state.communityFeeds.CommunityFeeds
  // );

  // const [feedLikeStatus, setFeedLikeStatus] = React.useState<{
  //   [key: string]: boolean;
  // }>({});

  // const [feedLikeRemove, setFeedLikeRemove] = React.useState<{
  //   [key: string]: boolean;
  // }>({});

  useEffect(() => {
    if (!loading) {
      setLoadings(false);
      setModalRemove(false);
    }
  }, [loading, setLoadings, setModalRemove]);
  // useMemo(() => {
  //   // Initialize the feedLikeStatus with false for each feed ID
  //   const initialStatus =
  //     communityFeeds &&
  //     communityFeeds?.reduce((acc, feed) => {
  //       acc[feed.id] = false;
  //       return acc;
  //     }, {} as { [key: string]: boolean });

  //   setFeedLikeStatus(initialStatus);
  //   setFeedLikeRemove(initialStatus);
  // }, [communityFeeds]);
  const user = useSelector((state: any) => state.user.userDetails);

  const navigate = useNavigate();

  const [createComment, { loading: isLoading }] = useMutation(
    CREATE_FEED_COMMENT,
    {
      onCompleted(data) {
        // console.log(data);
        if (refetch) {
          refetch();
        }
        setCommunityComment("");
      },
      onError: (err) => {
        console.log(err);
        const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
        console.log(errorMessage);
      },
    }
  );

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (communityFeed?.id && user?.id) {
      createComment({
        variables: {
          data: {
            comments: communityComment,
            communityFeed: {
              id: communityFeed?.id,
            },
            creator: {
              id: user?.id,
            },
          },
        },
      }).then(() => {
        console.log("submitted");
        setOnChange(false);
      });
    } else {
      showToast("You need to log in", "warn");
      navigate("/auth");
    }
  };

  return (
    <div
      className={`fixed inset-0 z-30 flex justify-center lg:py-10 pb-[100px] lg:pb-[80px]
      transition-colors overflow-y-hidden ${
        openModal && isLocked
          ? "visible backdrop-filter-[6px] bg-[#FFFFFFB8] h-full"
          : "invisible"
      }`}
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-md shadow 
       transition-all lg:w-[45%] w-full  ${
         openModal && isLocked ? "scale-100 opacity-100" : "scale-110 opacity-0"
       }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky z-20 shadow w-[100%] flex justify-between items-center p-2">
          <div className="flex flex-1 justify-center text-[#323232] items-center font-Poppins font-medium text-lg">
            {communityFeed?.creator?.firstName}'s post
          </div>
          <button
            className="py-2 px-2
            rounded-full text-transBlack
            bg-comPagBg active:bg-bgGrey
            hover:text-gray-600"
            onClick={onClose}
          >
            {""}
            <AiOutlineClose size={20} />
          </button>
        </div>
        <div
          className="flex flex-col w-full bg-comPagBg lg:h-full h-[90%] pb-10 lg:pb-0 lg:overflow-hidden overflow-y-auto"
          key={communityFeed?.updatedAt && 22}
        >
          <div className="w-full flex flex-col shadow lg:shadow-none lg:px-0 h-fit mb-2 py-4 bg-white lg:h-[98%] lg:overflow-y-auto">
            <div className="px-4">
              <DiscussMenu communityFeed={communityFeed} />
            </div>
            <ModalContent
              content={communityFeed?.content}
              feedImage={feedImages}
              feedVideo={feedVideo}
              communityFeed={communityFeed}
            />
            {feedImages &&
            feedVideo &&
            feedImages.length > 0 &&
            feedVideo.length > 0 ? (
              <DiscussVideoImage
                selectedVideos={feedVideo}
                imageUpload={feedImages}
                setShowAllImages={setShowAllImages}
                showAllImages={showAllImages}
              />
            ) : feedImages && feedImages.length > 0 ? (
              <div className="px-1">
                <DiscussImage
                  setShowAllImages={setShowAllImages}
                  showAllImages={showAllImages}
                  feedImages={feedImages}
                />
              </div>
            ) : (
              feedVideo &&
              feedVideo.length > 0 && (
                <DiscussVideo
                  videos={feedVideo}
                  setShowAllVideos={setShowAllImages}
                  showAllVideos={showAllImages}
                />
              )
            )}

            <div className="px-1 -mt-5">
              <ModalActivityReader
                communityFeed={communityFeed}
                loadings={loadings}
                modalRemove={modalRemove}
              />
              <Activity
                communityFeed={communityFeed}
                textArea={textArea}
                inputArea={inputArea}
                feedLikes={feedLikes}
                loading={loading}
                refetch={refetchLikes}
                setLoadings={setLoadings}
                setModalRemove={setModalRemove}
                refetchAllFeeds={refetch}
              />
            </div>
            <div className="hidden lg:flex w-full">
              <CommentList
                loadData={loadData}
                refetch={refetch}
                communityFeed={communityFeed}
              />
            </div>
          </div>
          <div className="lg:hidden flex w-full">
            <CommentList
              loadData={loadData}
              refetch={refetch}
              communityFeed={communityFeed}
            />
          </div>
          <div className="hidden lg:flex">
            <CommentsPost
              communityComment={communityComment}
              setCommunityComment={setCommunityComment}
              handleSubmit={handleSubmit}
              textArea={textArea}
              loading={isLoading}
            />
          </div>
        </div>
      </div>
      <div className="w-full fixed bottom-[69px]">
        <DiscussCommentModal
          setCommunityComment={setCommunityComment}
          communityComment={communityComment}
          handleSubmit={handleSubmit}
          loading={loading}
          textArea={textArea}
          onChange={onChange}
          setOnChange={setOnChange}
        />
      </div>
      <CommunityFooter isRefetching={isRefetching} />
    </div>
  );
};

export default DiscussModal;
